var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkoOp2Yellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OKO_op2_yellow",
    clipPath: "url(#clip0_525_856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5558 0.0502482C76.828 -1.25334 101.805 22.253 99.8998 51.968C97.8775 83.5298 65.7559 88.5436 40.1521 86.3626C-23.0049 80.9978 -4.83827 2.38166 47.5558 0.0502482Z",
    fill: "#F6F416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.5387 34.3026C59.5387 28.3696 65.0038 23.5647 71.7473 23.5647C78.4908 23.5647 83.9559 28.3696 83.9559 34.3026",
    fill: "#002E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.3658 34.3026C66.3658 31.7456 68.7808 29.6565 71.7557 29.6565C74.7305 29.6565 77.1455 31.7456 77.1455 35.3026",
    fill: "#F6F416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0663 35.0047C18.0663 29.0717 23.5314 24.2668 30.2749 24.2668C37.0185 24.2668 42.4835 29.0717 42.4835 35.0047",
    fill: "#002E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.8935 35.0048C24.8935 32.4477 27.3084 30.3586 30.2833 30.3586C33.2581 30.3586 35.6731 32.4477 35.6731 36.0048",
    fill: "#F6F416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.7902 46.6366C33.1412 47.0043 33.3501 47.5057 33.3501 48.0071C33.3501 48.5085 33.1328 49.0098 32.7902 49.3775C32.4225 49.7285 31.9378 49.9374 31.4197 49.9374C30.9017 49.9374 30.417 49.7201 30.0493 49.3775C29.6983 49.0098 29.4894 48.5252 29.4894 48.0071C29.4894 47.489 29.6983 47.0043 30.066 46.6366C30.7847 45.918 32.0799 45.918 32.7902 46.6366Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M62.1376 52.0013C61.3604 52.2604 60.8674 53.0208 60.8674 53.8397V57.6836C60.8674 58.5026 61.3688 59.263 62.1459 59.522C63.4913 59.9649 64.7364 58.9789 64.7364 57.7003V53.8314C64.7364 52.5529 63.4913 51.5585 62.1459 52.0097L62.1376 52.0013Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.4001 48.1324C35.623 48.3915 35.1299 49.1519 35.1299 49.9708V53.8147C35.1299 54.6337 35.6313 55.3941 36.4085 55.6531C37.7538 56.096 38.9989 55.11 38.9989 53.8314V49.9625C38.9989 48.684 37.7538 47.6896 36.4085 48.1408L36.4001 48.1324Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.5754 46.2189C41.7983 46.478 41.3053 47.2384 41.3053 48.0573V59.6308C41.3053 60.4497 41.8066 61.2101 42.5838 61.4692C43.9291 61.9121 45.1742 60.926 45.1742 59.6475V48.0406C45.1742 46.7621 43.9291 45.7677 42.5838 46.2189H42.5754Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M56.6307 48.216C55.9622 48.5168 55.5695 49.2271 55.5695 49.9541V61.5443C55.5695 62.3632 56.0709 63.1237 56.848 63.3827C58.1934 63.8256 59.4385 62.8395 59.4385 61.561V49.9541C59.4385 48.6087 58.0597 47.5809 56.6307 48.216Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67.9452 44.2636C67.1681 44.5227 66.675 45.2831 66.675 46.102V57.6755C66.675 58.4944 67.1764 59.2548 67.9536 59.5139C69.2989 59.9568 70.544 58.9707 70.544 57.6922V46.0853C70.544 44.8068 69.2989 43.8124 67.9536 44.2636H67.9452Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M49.9624 40.4029C49.1853 40.6452 48.6923 41.3639 48.6923 42.1243V67.469C48.6923 68.2378 49.1936 68.9481 49.9708 69.1904C51.3161 69.6082 52.5612 68.6806 52.5612 67.4773V42.0992C52.5612 40.8959 51.3161 39.9684 49.9708 40.3862L49.9624 40.4029Z",
    fill: "#605DEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M75.6413 45.2663C75.9923 45.634 76.2012 46.1353 76.2012 46.6367C76.2012 47.1381 75.984 47.6395 75.6413 48.0071C75.2737 48.3581 74.789 48.567 74.2709 48.567C73.7528 48.567 73.2682 48.3498 72.9005 48.0071C72.5495 47.6395 72.3406 47.1548 72.3406 46.6367C72.3406 46.1186 72.5495 45.634 72.9172 45.2663C73.6358 44.5476 74.9311 44.5476 75.6413 45.2663Z",
    fill: "#605DEC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 86.8054,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkoOp2Yellow);
export default __webpack_public_path__ + "static/media/OKO_op2_yellow.45e1add3f3de9864a568172c3eaf4d32.svg";
export { ForwardRef as ReactComponent };